import React from 'react';

const Process = () => {
  return (
    <div className="process-area py-120">
      <div className="container">
        <div className="row">
          <div
            className="col-lg-6 mx-auto wow fadeInDown"
            data-wow-duration="1s"
            data-wow-delay=".25s"
          >
            <div className="site-heading text-center">
              <span className="site-title-tagline">
                Process
              </span>
              <h2 className="site-title">
                How it Works
              </h2>
              <p>
                Discover how we make things happen in just a few easy steps.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 col-lg-4 col-xl-3">
            <div className="process-item">
              <span className="process-count">01</span>
              <div className="process-icon">
                <i className="fal fa-user-plus"></i>
              </div>
              <div className="process-content">
                <h5>
                  Create Your Account
                </h5>
                <p>
                  Register quickly and start your journey with us.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 col-xl-3">
            <div className="process-item">
              <span className="process-count">02</span>
              <div className="process-icon">
                <i className="fal fa-file-upload"></i>
              </div>
              <div className="process-content">
                <h5>Submit Your Documents</h5>
                <p>
                  Upload all necessary documents to complete your profile.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 col-xl-3">
            <div className="process-item">
              <span className="process-count">03</span>
              <div className="process-icon">
                <i className="fal fa-search"></i>
              </div>
              <div className="process-content">
                <h5>Find Opportunities</h5>
                <p>
                  Browse through our curated list of opportunities that match your skills.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 col-xl-3">
            <div className="process-item">
              <span className="process-count">04</span>
              <div className="process-icon">
                <i className="fal fa-paper-plane"></i>
              </div>
              <div className="process-content">
                <h5>Apply and Get Hired</h5>
                <p>
                  Send your application and step closer to your dream job.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Process;
